import axiosInstance from '../axiosInstance';

const getAll = async () => {
  return axiosInstance.get('/workspace').then((response) => response.data);
};

const create = async (name) => {
  return axiosInstance.post('/workspace', { name }).then((response) => response.data);
};

const setActive = async (workspaceId) => {
  return axiosInstance.put('/workspace/active', { workspaceId }).then((response) => response.data);
};

const rename = async (workspaceId, name) => {
  return axiosInstance.put(`/workspace/${workspaceId}`, { name }).then((response) => response.data);
};

const addMember = async (workspaceId, member, role, inviteName, inviteEmail) => {
  return axiosInstance
    .post(`/workspace/${workspaceId}/member`, {
      member,
      role,
      name: inviteName,
      email: inviteEmail
    })
    .then((response) => response.data);
};

const removeMember = async (workspaceId, memberId, email, inviteId, pending = false) => {
  return axiosInstance
    .delete(`/workspace/${workspaceId}/member`, {
      data: {
        memberId,
        email,
        inviteId,
        pending
      }
    })
    .then((response) => response.data);
};

const updateMemberRole = async (workspaceId, memberId, role) => {
  return axiosInstance
    .put(`/workspace/${workspaceId}/member/role`, {
      memberId,
      role
    })
    .then((response) => response.data);
};

const createInitial = async (name) => {
  return axiosInstance.post('/workspace/initial', { name }).then((response) => response.data);
};

const workspaceService = {
  getAll,
  create,
  setActive,
  rename,
  addMember,
  updateMemberRole,
  removeMember,
  createInitial
};

export default workspaceService;
